import { TemplateVariableTableProps, VariableItem } from '@/template/interface'
import { getAddressName } from '@/utils/dataType'
import { getFormatMessage, mergeTableColumns } from '@/utils/utils'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Modal, Space, Table } from 'antd'
import React from 'react'

const { confirm } = Modal

export const TemplateVariableTable: React.FC<TemplateVariableTableProps> = (
  props: TemplateVariableTableProps
) => {
  const formatMessage = getFormatMessage()

  const defaultColumns = [
    {
      title: formatMessage({ id: 'app.template.variable.table.index' }),
      key: 'app.template.variable.table.index',
      render: (text: any, record: any, index: any) => index + 1
    },
    {
      title: formatMessage({ id: 'app.template.variable.table.name' }),
      key: 'app.template.variable.table.name',
      dataIndex: 'name'
    },
    {
      title: formatMessage({ id: 'app.template.variable.table.deviceId' }),
      key: 'app.template.variable.table.deviceId',
      render: (text: any, record: any, index: any) => {
        const plc = props.plcs?.find((x) => x.id == record.deviceId)
        return plc && plc.alias
      }
    },
    {
      title: formatMessage({ id: 'app.template.variable.table.mainAddress' }),
      key: 'app.template.variable.table.mainAddress',
      render: (text: any, record: VariableItem, index: any) =>
        getAddressName(record, props.plcs)
    },
    {
      title: formatMessage({ id: 'app.template.variable.table.remark' }),
      key: 'app.template.variable.table.remark',
      dataIndex: 'description'
    },
    {
      title: formatMessage({ id: 'app.template.variable.table.operation' }),
      key: 'app.template.variable.table.operation',
      render: (text: any, record: VariableItem) => (
        <Space size='middle'>
          <a onClick={() => handleEdit(record)}>
            {formatMessage({
              id: 'app.template.variable.table.operation.edit'
            })}
          </a>
          <a onClick={() => handleDelete(record)}>
            {formatMessage({
              id: 'app.template.variable.table.operation.delete'
            })}
          </a>
        </Space>
      )
    }
  ]
  const columns = mergeTableColumns(defaultColumns, props.columns)

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      if (props.onSelect) {
        props.onSelect(selectedRows)
      }
    }
  }

  const handleEdit = (item: VariableItem) => {
    if (props.onEdit) {
      props.onEdit(item)
    }
  }

  const handleDelete = (item: VariableItem) => {
    if (props.showDeleteModal) {
      confirm({
        title: formatMessage({ id: 'app.modal.confirm.delete' }),
        icon: <ExclamationCircleOutlined />,
        okText: formatMessage({ id: 'app.modal.ok' }),
        cancelText: formatMessage({ id: 'app.modal.cancel' }),
        onOk() {
          if (props.onDelete) {
            props.onDelete(item)
          }
        }
      })
    } else {
      if (props.onDelete) {
        props.onDelete(item)
      }
    }
  }

  return (
    <Table
      size={props.size || 'middle'}
      rowKey='id'
      columns={columns}
      dataSource={props.data}
      pagination={props.pagination}
      rowSelection={
        props.selectable
          ? {
              type: props.selectionType,
              ...rowSelection,
              ...props.rowSelection
            }
          : undefined
      }
    />
  )
}
